
define('common/recaptcha-constants',['jquery', 'ui-helper/storage-helper', 'eteration/eteration-i18n'], function($, storageHelper, i18n) {
    var domain = "https://www.google.com/recaptcha/api.js";
    var countryCodeField = "cd_GeoCountry";
    var countryCode = storageHelper.getItem({ key: countryCodeField, webStorageType: storageHelper.Stores.SESSION_STORAGE });

    var toCDNPATH = function(url) {
        if(window.cdnDomain){
            url = window.cdnDomain+ url;
        }
        return url;
    };

    if(!countryCode) {
        $.ajax({
            type: "GET",
            url: toCDNPATH("/com.thy.web.online.common/api/parameters/clientinfo"),
            async: true,
            cache: false,
            success: function (response) {
                if (response && response.data && response.data[countryCodeField]) {
                    // "CN" => China country code
                    storageHelper.setItem({
                        key: countryCodeField,
                        value: response.data[countryCodeField],
                        webStorageType: storageHelper.Stores.SESSION_STORAGE
                    });
                    if (response.data[countryCodeField] === "CN") {
                        domain = "";
                    }
                }
            }
        });
    } else if (countryCode === "CN") {
        domain = "";
    }

    function addRecaptchaV2(additionalScript, onLoadCallback) {
        setTimeout(function() {
            if(domain) {
                var onLoadString = onLoadCallback ? '?onload=' + onLoadCallback + '&' : '';
                var explicitString = onLoadCallback ? 'render=explicit&hl=' : '?explicit&hl=';
                var script = '<script src="' + domain + onLoadString + explicitString + i18n.getUserLocale() + '" async defer></script>';

                if(additionalScript) {
                    script += additionalScript;
                }

                $($('head')[0]).append(script);
            }
        }, 750)
    }

    function addRecaptchaV2ForEtrAjax() {
        setTimeout(function() {
            if(domain) {
                $('body').prepend('<script id="captchaApi" src="' + domain + '"></script>')
            }
        }, 750);
    }

    function getDomain() {
        setTimeout(function() { return domain; }, 1000);
    }

    return {
        domain : getDomain,
        addRecaptchaV2: addRecaptchaV2,
        addRecaptchaV2ForEtrAjax: addRecaptchaV2ForEtrAjax
    };
});